<template>
  <el-table-column
    prop="registration_number"
    sortable="custom"
    label="Szj szám"
    show-overflow-tooltip
    min-width="110px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.registration_number">{{ scope.row.registration_number }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'registration_number',
  };
</script>
